<template>
  <div class="container" v-if="isLoggedIn">
    <!-- 서브상단영역 -->

    <Banner
      title="Activity"
      subtitle="Activity"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />
    <!-- //서브상단영역 -->

    <BoardNavbar />

    <div class="width_wrap">
      <div class="body_content">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">재능진로전공직업 탐색 프로젝트</h1>
        <!-- //서브 타이틀영역 -->

        <div class="menu-A-list-wrap">
          <Talent_Items />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Talent_Items from "@/views/product/activity/Talent_Items.vue";
import BoardNavbar from "@/views/product/activity/Navbar.vue";
import Banner from "@/components/Banner.vue";
import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";
const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;

  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.sub_scroll_wrap {
  overflow: hidden;
  height: 39px;
  border-bottom: 1px solid #ccc;
  background: #fff;
}
.sub_scroll_wrap > div {
  position: relative; /*padding: 0 30px;*/
}
.sub_scroll_wrap > div > div {
  overflow-x: scroll;
}
.sub_scroll_wrap > div > div .scroll_nav {
  display: inline-block;
  min-width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
  font-size: 0;
  text-align: center;
  white-space: nowrap;
}
.sub_scroll_wrap > div > div .scroll_nav li {
  display: inline-block;
}
.sub_scroll_wrap > div > div .scroll_nav li a {
  display: inline-block;
  height: 39px;
  line-height: 39px;
  padding: 0 12px;
  font-size: 13px;
  color: #bbb;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  box-sizing: border-box;
  font-weight: 600;
}
.sub_scroll_wrap > div > div .scroll_nav li.on a {
  color: #be7b42;
  font-weight: 600;
}
.sub_scroll_wrap > div i {
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 39px;
}
.sub_scroll_wrap > div i.prev:before {
  content: "";
  position: absolute;
  top: 0;
  left: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-right-color: #333;
}
.sub_scroll_wrap > div i.next {
  right: 0;
  left: inherit;
}
.sub_scroll_wrap > div i.next:before {
  content: "";
  position: absolute;
  top: 0;
  right: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-left-color: #333;
}
@media screen and (min-width: 768px) {
  .sub_scroll_wrap > div i {
    display: none;
  }
}
@media screen and (min-width: 1200px) {
  .sub_scroll_wrap {
    overflow: visible;
    height: auto;
    border-bottom: none;
    background: #fff;
    box-shadow: 3px 3px 3px rgb(0 0 0 / 10%);
  }
  .sub_scroll_wrap > div {
    position: relative;
    padding: 0;
  }
  .sub_scroll_wrap > div > div {
    overflow: hidden;
  }
  .sub_scroll_wrap > div > div .scroll_nav {
    display: table;
    margin: 0;
    width: 100%;
    padding: 0;
    white-space: normal;
    text-align: left;
    border-collapse: collapse;
  }
  .sub_scroll_wrap > div > div .scroll_nav li {
    display: table-cell;
    width: 33%;
    position: relative;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    background: #bbb;
    width: 1px;
    height: 15px;
    margin-top: -7px;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:last-child:after {
    display: none;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:before {
    position: absolute;
    visibility: hidden;
    left: 0;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 3px;
    background: #be7b42;
    content: "";
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: all 0.2s ease-in-out 0s;
    transition: all 0.2s ease-in-out 0s;
    opacity: 0.85;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 60px;
    line-height: 60px;
    padding: 0 5px;
    font-size: 16px;
    text-align: center;
    color: #bbbbbb;
    font-weight: 600;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a:hover {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on a {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on:before,
  .sub_scroll_wrap > div > div .scroll_nav li:hover:before {
    visibility: visible;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}

.sub04_wrap * {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  box-sizing: border-box;
  word-break: keep-all;
}
.sub04_wrap > ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.sub04_wrap > ul li {
  width: 48%;
}
.sub04_wrap > ul li figure {
  border: 1px solid #ddd;
}
.sub04_wrap > ul li:nth-child(-n + 2) {
  margin-bottom: 30px;
}
.sub04_wrap > ul li a {
  display: block;
  border-radius: 10px;
  position: relative;
  transition: all.2s;
}
.sub04_wrap > ul li h1 {
  font-size: 14px;
  font-weight: 500;
  padding-top: 15px;
  text-align: center;
}
.sub04_wrap > ul li a > div.bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: none;
  opacity: 0;
  transition: all.2s;
}
.sub04_wrap > ul li a > div.bg > span {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  line-height: 80px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  background: #ba7b3d;
  color: #fff;
  font-weight: 500;
}
@media screen and (min-width: 768px) {
  .sub04_wrap > ul {
    justify-content: normal;
  }
  .sub04_wrap > ul li h1 {
    font-size: 16px;
  }
  .sub04_wrap > ul li {
    width: 23.5%;
    margin-right: 2%;
  }
  .sub04_wrap > ul li:nth-child(-n + 2) {
    margin-bottom: 0px;
  }
  .sub04_wrap > ul li:last-child {
    margin-right: 0;
  }
  .sub04_wrap > ul li a:hover > div.bg {
    display: block;
    opacity: 1;
  }
}
</style>
